import { Component, OnInit } from '@angular/core';
import { AssigTripsService } from '../../../assigntrips-service/assigntrips-service';

@Component({
  selector: 'app-planner-template-list',
  templateUrl: './planner-template-list.component.html',
  styleUrls: ['./planner-template-list.component.css']
})
export class PlannerTemplateListComponent implements OnInit {
  search;
  status = "active";
  templates = [];

  constructor(
    private assignTripsService: AssigTripsService
  ) { }

  ngOnInit() {
    this.getTemplates();
  }

  getTemplates() {
    this.assignTripsService
      .getTemplates(this.status)
      .subscribe(data => {
        if (data && data.length) {
          this.templates = data;
        }
      });
  }

    onChangeStatus(evt) {
       this.getTemplates();
  }

}
